export const formatDate = (fecha: any): string => {
  let fechaJavaScript;

  if (fecha instanceof Date) {
    fechaJavaScript = fecha;
  } else {
    fechaJavaScript = new Date(
      fecha?.seconds * 1000 + fecha?.nanoseconds / 1e6
    );
  }

  const dia = fechaJavaScript.getDate();
  const mes = fechaJavaScript.getMonth() + 1;
  const ano = fechaJavaScript.getFullYear();
  const hora = fechaJavaScript.getHours();
  const minutos = fechaJavaScript.getMinutes();

  return `${dia}/${mes}/${ano}  ${hora}:${minutos <= 9 ? `0${minutos}` : minutos}`;
};

export const formatDate2 = (fecha: any): string => {
  let fechaJavaScript;

  if (fecha instanceof Date) {
    fechaJavaScript = fecha;
  } else {
    fechaJavaScript = new Date(
      fecha?.seconds * 1000 + fecha?.nanoseconds / 1e6
    );
  }

  const dia = fechaJavaScript.getDate();
  const mes = fechaJavaScript.getMonth() + 1;
  const ano = fechaJavaScript.getFullYear();

  return `${dia <= 9 ? `0${dia}` : dia}/${mes <= 9 ? `0${mes}` : mes}/${ano}`;
};

export const formatearNumeros = (
  numero: number | null | undefined
): string => {
  if (numero === undefined || numero === null) {
    return "0";
  }

  return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
